export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const resetPasswordFailure = error => ({
    type: RESET_PASSWORD_FAILURE,
    payload: error,
    error: true,
});
